import i18next from 'i18next'
import { useTranslation } from 'react-i18next'

const MarketingInformationSystems = () => {
  const { t } = useTranslation('MarketingInformationSystems')
  const lang = i18next.language
  const rtl = lang === 'ar'
  return {
    id: 11,
    category: t('category_ms11'),
    title: t('title_ms11'),
    subTitle: t('subTitle_ms11'),
    main: t('main_ms11'),
    how: t('how_ms11'),
    usedInModels: [],
    tags: rtl
      ? ['الميزة التنافسية', 'معلومات التسويق']
      : ['Competitive Advantage', 'Marketing Information'],
    examples: t('examples_ms11'),
    hashTagType: 'markStraAspect',
  }
}

export default MarketingInformationSystems
